$(document).ready(function () {
  // ------------------- TB_Diamond_CMS Start -------------------
  var tb_daimond_cms = $("#TB-Diamond-cms .owl-carousel").owlCarousel({
    items: 9, //1 items above 1000px browser width
    nav: false,
    dots: false,
    loop: false,
    margin: 50,
    autoplayHoverPause: true,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      361: {
        items: 2,
      },
      481: {
        items: 3,
        margin: 15,
      },
      576: {
        items: 4,
        margin: 15,
      },
      768: {
        items: 5,
        margin: 20,
      },
      992: {
        items: 5,
        margin: 30,
      },
      1300: {
        items: 6,
      },
      1400: {
        items: 7,
        margin: 50,
      },
      1600: {
        items: 7,
        margin: 20,
      },
      1700: {
        items: 8,
        margin: 50,
      },
      1800: {
        items: 10,
      },
    },
  });
  // ------------------- TB_Diamond_CMS End -------------------

  // ------------------- TB-video-cms Start -------------------
  var tb_video_cms = $("#TB-video-cms .owl-carousel").owlCarousel({
    items: 5,
    nav: false,
    dots: true,
    loop: false,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
      },
      768: {
        items: 3,
        margin: 15,
      },
      1200: {
        items: 4,
      },
      1500: {
        items: 5,
      },
    },
  });
  // ------------------- TB-video-cms End -------------------

  // ------------------- TB_Services_CMS Start -------------------
  var tb_services_cms = $("#tb-servises-cms .tb-servises-flex").owlCarousel({
    items: 4, //1 items above 1000px browser width
    nav: false,
    dots: false,
    loop: false,
    center: false,
    autoplayHoverPause: true,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      544: {
        items: 2,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
  // ------------------- TB_Services_CMS End -------------------
  // ------------------- TB_Testimonial-CMS Start -------------------
  var tb_testimonial_cms = $("#TB-Testimonial-cms .owl-carousel").owlCarousel({
    loop: false,
    margin: 30,
    nav: false,
    dots: true,
    responsive: {
      0: { items: 1 },
      768: { items: 2, margin: 15 },
      992: { items: 3 },
      1300: { items: 4 },
    },
  });
  // ------------------- TB_Testimonial-CMS End -------------------
  // ------------------- TB_category_featured Start -------------------
  var TB_category_featured = $(
    "#TB-category-featured .tb-category-featured-carousel"
  ).owlCarousel({
    items: 8, //1 items above 1000px browser width
    nav: false,
    dots: true,
    loop: false,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      361: {
        items: 2,
      },
      481: {
        items: 3,
      },
      768: {
        items: 4,
      },
      992: {
        items: 5,
      },
      1200: {
        items: 6,
      },
      1600: {
        items: 7,
      },
      1700: {
        items: 8,
      },
    },
  });
  // ------------------- TB_category_featured End -------------------
});
